module.exports = __webpack_public_path__ + "static/media/kg.97843c34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kg.png
// module id = 1894
// module chunks = 0